import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import TopBar from '../../comum/components/TopBar'
import SideBar from '../../comum/components/SideBar'
import ScrollUpButton from "react-scroll-up-button";
import {Redirect} from "react-router-dom";
import TituloPagina from "../../comum/components/TituloPagina";
import {toast} from "react-toastify";
import { Login } from '../../login/tela/Login';
import { SetaSubirDupla } from '../../comum/components/Icones';
import lscache from 'lscache'

export default function DataWrapper(Component) {
    @inject("store")
    @inject("routes")
	@observer
	class DataFetcher extends Component {
		constructor(props) {
			super(props);
            this.appStore = this.props.store.appStore;
            this.loginStore = this.props.store.loginStore;
            this.tituloPaginaStore = this.props.store.tituloPaginaStore;
            this.formStore = this.props.store.formStore;
            this.modalStore = this.props.store.modalStore;
            this.routes = this.props.routes;
            this.token = lscache.get('access_token') 
            this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

            this.createSubmenuState();
            // console.log(this.routes);
        }
        
        createSubmenuState(){
            let i;
            for(i=0; i< this.routes.lenth;i++){
                console.log(this.routes[i]);
            }
        }

		componentWillMount() {
            this.appStore.contentBackgroundWhite = false;
        }

        componentDidMount() {
            if(this.appStore.width < 768) {
                this.appStore.sidebarFechado = true;
            }
            this.updateWindowDimensions();
            window.addEventListener('resize', this.updateWindowDimensions);
        }

        componentDidUpdate() {
            if(this.appStore.width < 768 && !this.appStore.sidebarFechado){
                document.body.classList.add("noScroll")
            }else if(document.body.classList.contains("noScroll")){
                document.body.classList.remove("noScroll")
            }
        }

        componentWillUnmount() {
            window.removeEventListener('resize', this.updateWindowDimensions);
            {/*TODO: refatorar forms*/}
            this.formStore.setSubmitted(false);
            this.formStore.setSubmitMensagemErro("");
            this.modalStore.setSubmitted(false);
            this.modalStore.setSubmitMensagemErro("");
            this.formStore.acaoEnviada = false;
            this.tituloPaginaStore.setTitulo("");
            this.tituloPaginaStore.setBotoesMobile([]);
            this.appStore.contentBackgroundWhite = false;
        }

        updateWindowDimensions() {
            this.appStore.width = window.innerWidth;
        }

        render() {
            const minimizedWrapper = this.appStore.sidebarFechado ? "wrapper minimized-content" : "wrapper";
            const wrapperClass = this.appStore.gridMode && this.appStore.width > 768 ? minimizedWrapper + " white" : minimizedWrapper;
            return(
                <div className={wrapperClass}>
                    {true ? (
                        <div className={this.appStore.contentBackgroundWhite ? "content background-white" : "content"} >
                            <ScrollUpButton
                                ContainerClassName="voltar-topo"
                                TransitionClassName="voltar-topo-transition">
                                <div>
                                    Voltar ao topo <SetaSubirDupla width={ 16 } height={ 16 }/>
                                </div>
                                
                            </ScrollUpButton>
                            {this.token ? <TopBar exibeSair={true} /> : <TopBar exibeSair="Login" />}
                            <SideBar />
                            <div className="pages-content">
                                <TituloPagina />
                                <Component {...this.props} />
                            </div>
                    </div>) :(
                        <div>
                            {toast.dismiss() && <Redirect to="/login" component={<Login />}/>}
                        </div>
                    )}
                </div>
            );
        }

	}
	return DataFetcher;
}



// WEBPACK FOOTER //
// ./src/modules/principal/containers/DataWrapper.js